export default "__VITE_ASSET__DQSMPGZr__"